import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { REVIEWS_SEGMENT_OPTIONS } from "./reviewsSegment";
import type { ReviewsSegment } from "./types";
import { SegmentPills } from "../shared/SegmentPills";

interface ReviewsSegmentPillsProps {
  value: ReviewsSegment;
  onChange: (value: ReviewsSegment) => void;
  visibleSegments?: readonly ReviewsSegment[];
}

export const ReviewsSegmentPills = memo(function ReviewsSegmentPills({
  value,
  onChange,
  visibleSegments,
}: ReviewsSegmentPillsProps) {
  const { t } = useTranslation();

  const options = useMemo(
    () =>
      REVIEWS_SEGMENT_OPTIONS.map((option) => ({
        value: option.value,
        label: t(`analytics.reviews.segments.${option.value}`, option.label),
      })).filter(
        (option) =>
          visibleSegments === undefined ||
          visibleSegments.includes(option.value),
      ),
    [visibleSegments, t],
  );

  return (
    <SegmentPills
      value={value}
      options={options}
      onChange={onChange}
      ariaLabel={t("analytics.aria.reviewsSegments", "Reviews segments")}
    />
  );
});
